export default __webpack_public_path__ + "static/media/apr2023-2.3b43ac85.jpg";